export const FETCH_VERIFIED_BILL_REQUEST_DATA = 'FETCH_VERIFIED_BILL_REQUEST_DATA';
export const FETCH_VERIFIED_BILL_SUCCESS_DATA = 'FETCH_VERIFIED_BILL_SUCCESS_DATA';
export const FETCH_VERIFIED_BILL_FAILURE_DATA = 'FETCH_VERIFIED_BILL_FAILURE_DATA';


export const DELETE_VERIFIED_BILL_REQUEST_DATA = 'DELETE_VERIFIED_BILL_REQUEST_DATA';
export const DELETE_VERIFIED_BILL_SUCCESS_DATA = 'DELETE_VERIFIED_BILL_SUCCESS_DATA';
export const DELETE_VERIFIED_BILL_FAILURE_DATA = 'DELETE_VERIFIED_BILL_FAILURE_DATA';
